module.exports = __webpack_public_path__ + "img/scrape_web_icon.194148fd.svg";